export const Constants = {
  TAG_NAME: 'pop-product-center-predictive-popover',
} as const;
